import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { list_type, record_type, option_type, class_type, int32_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { ProductModule_toInt, ProductModule_ofInt, Product$reflection } from "../../DomainTypes.js";
import { NormalizedSubproduct_ofSubproductDTO_Z9763C53, NormalizedSubproduct$reflection, GenericSubproductDTO$reflection, SubproductLevel_get_toString, SubproductLevel_get_ofString, SubproductLevel$reflection } from "../Subproducts/Model.js";
import { DateFormat_get_yyyy$002DMM$002Ddd, DateModule_toStr } from "../../Svea.Dry/Time.js";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { map } from "../../fable_modules/fable-library.3.7.20/List.js";

export class ContractSubproductDTO extends Record {
    constructor(Name, ProductNr, ActiveFrom, ActiveTo, SerialNumber, ArgumentBlobValue, SortOrder, SubproductLevel) {
        super();
        this.Name = Name;
        this.ProductNr = (ProductNr | 0);
        this.ActiveFrom = ActiveFrom;
        this.ActiveTo = ActiveTo;
        this.SerialNumber = (SerialNumber | 0);
        this.ArgumentBlobValue = ArgumentBlobValue;
        this.SortOrder = SortOrder;
        this.SubproductLevel = SubproductLevel;
    }
}

export function ContractSubproductDTO$reflection() {
    return record_type("Containers.ContractSubproducts.Model.ContractSubproductDTO", [], ContractSubproductDTO, () => [["Name", string_type], ["ProductNr", int32_type], ["ActiveFrom", class_type("System.DateOnly")], ["ActiveTo", option_type(class_type("System.DateOnly"))], ["SerialNumber", int32_type], ["ArgumentBlobValue", string_type], ["SortOrder", option_type(int32_type)], ["SubproductLevel", string_type]]);
}

export class ContractSubproduct extends Record {
    constructor(Id, Name, Product, ActiveFrom, ActiveTo, SerialNumber, ArgumentBlobValue, SortOrder, SubproductLevel) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.Product = Product;
        this.ActiveFrom = ActiveFrom;
        this.ActiveTo = ActiveTo;
        this.SerialNumber = (SerialNumber | 0);
        this.ArgumentBlobValue = ArgumentBlobValue;
        this.SortOrder = SortOrder;
        this.SubproductLevel = SubproductLevel;
    }
}

export function ContractSubproduct$reflection() {
    return record_type("Containers.ContractSubproducts.Model.ContractSubproduct", [], ContractSubproduct, () => [["Id", string_type], ["Name", string_type], ["Product", Product$reflection()], ["ActiveFrom", class_type("System.DateOnly")], ["ActiveTo", option_type(class_type("System.DateOnly"))], ["SerialNumber", int32_type], ["ArgumentBlobValue", string_type], ["SortOrder", option_type(int32_type)], ["SubproductLevel", SubproductLevel$reflection()]]);
}

export function ContractSubproduct_FromDTO_1D5BB27C(dto) {
    let arg_1;
    return new ContractSubproduct((arg_1 = DateModule_toStr(DateFormat_get_yyyy$002DMM$002Ddd(), dto.ActiveFrom), toText(printf("%s|%s|%i"))(dto.Name)(arg_1)(dto.SerialNumber)), dto.Name, ProductModule_ofInt(dto.ProductNr), dto.ActiveFrom, dto.ActiveTo, dto.SerialNumber, dto.ArgumentBlobValue, dto.SortOrder, SubproductLevel_get_ofString()(dto.SubproductLevel));
}

export function ContractSubproduct_ToDTO_Z1109ED7D(s) {
    return new ContractSubproductDTO(s.Name, ProductModule_toInt(s.Product), s.ActiveFrom, s.ActiveTo, s.SerialNumber, s.ArgumentBlobValue, s.SortOrder, SubproductLevel_get_toString()(s.SubproductLevel));
}

export class AllSubproductsResponseDTO extends Record {
    constructor(ClientSubproducts, ContractTypeSubproducts, PriceListSubproducts, ContractSubproducts) {
        super();
        this.ClientSubproducts = ClientSubproducts;
        this.ContractTypeSubproducts = ContractTypeSubproducts;
        this.PriceListSubproducts = PriceListSubproducts;
        this.ContractSubproducts = ContractSubproducts;
    }
}

export function AllSubproductsResponseDTO$reflection() {
    return record_type("Containers.ContractSubproducts.Model.AllSubproductsResponseDTO", [], AllSubproductsResponseDTO, () => [["ClientSubproducts", list_type(GenericSubproductDTO$reflection())], ["ContractTypeSubproducts", list_type(GenericSubproductDTO$reflection())], ["PriceListSubproducts", list_type(GenericSubproductDTO$reflection())], ["ContractSubproducts", list_type(ContractSubproductDTO$reflection())]]);
}

export class AllSubproductsResponse extends Record {
    constructor(ClientSubproducts, ContractTypeSubproducts, PriceListSubproducts, ContractSubproducts) {
        super();
        this.ClientSubproducts = ClientSubproducts;
        this.ContractTypeSubproducts = ContractTypeSubproducts;
        this.PriceListSubproducts = PriceListSubproducts;
        this.ContractSubproducts = ContractSubproducts;
    }
}

export function AllSubproductsResponse$reflection() {
    return record_type("Containers.ContractSubproducts.Model.AllSubproductsResponse", [], AllSubproductsResponse, () => [["ClientSubproducts", list_type(NormalizedSubproduct$reflection())], ["ContractTypeSubproducts", list_type(NormalizedSubproduct$reflection())], ["PriceListSubproducts", list_type(NormalizedSubproduct$reflection())], ["ContractSubproducts", list_type(ContractSubproduct$reflection())]]);
}

export function AllSubproductsResponse_FromDTO_3E78A01F(dto) {
    return new AllSubproductsResponse(map(NormalizedSubproduct_ofSubproductDTO_Z9763C53, dto.ClientSubproducts), map(NormalizedSubproduct_ofSubproductDTO_Z9763C53, dto.ContractTypeSubproducts), map(NormalizedSubproduct_ofSubproductDTO_Z9763C53, dto.PriceListSubproducts), map(ContractSubproduct_FromDTO_1D5BB27C, dto.ContractSubproducts));
}

